import { createAuth } from '@vendys/web-lib';
import { Modal } from 'antd';
import api from 'config';
import storage from 'helpers/storage';
import history from 'vendys/utils/history';

// 403 안내 모달 중복 방지 — 한 화면의 동시 다발 호출이 전부 403이어도 모달은 1개만
let isForbiddenModalOpen = false;

export const auth = createAuth({
  authURL: api.config.authAPI,
  clientId: api.config.client_id,
  clientSecret: api.config.client_secret,
  kmsKeyId: api.config.kms_key_id,
  userAgent: () => `Vendys/1.0 ${JSON.stringify({ client: 'SikdaeUser', os: 'WEB' })}`,
  // 인터셉터 토큰 갱신 실패(세션 만료) — 안내 토스트는 로그인 화면 도착 후 표시
  onAuthExpired: () => {
    storage.clearLogout();
    sessionStorage.setItem('sessionExpiredNotice', '1');
    history.push('/');
  },
  // 비즈니스 API 403(권한 부족) — 세션은 유효하므로 로그아웃 없이 안내만
  onForbidden: (error) => {
    if (isForbiddenModalOpen) return;
    isForbiddenModalOpen = true;
    const data = (error && error.response && error.response.data) || {};
    Modal.warning({
      title: data.title || '접근 권한이 없습니다',
      content: data.message || '해당 기능에 대한 권한이 없습니다. 관리자에게 문의해 주세요.',
      okText: '확인',
      afterClose: () => {
        isForbiddenModalOpen = false;
      }
    });
  }
});
